// extracted by mini-css-extract-plugin
export default {"body":"TaskExpandable_body__FZePx","header":"TaskExpandable_header__FjEwc"};